
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/efdelta-discharge-information",
      function () {
        return require("private-next-pages/efdelta-discharge-information/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/efdelta-discharge-information"])
      });
    }
  